/**
 * The key value used for storing/retrieving information about import
 */
export const ImportSourcesKey = 'Monarch.Import.History';
